<template>
    <div class="indexBox">
        <div class="title">寻找聪明钱</div>
        <div class="listBox">
            <div class="listTitleBox">
                <div class="numTitle listTitleStyle">#</div>
                <div class="addressTitle listTitleStyle" style="padding:0 0 0 0">地址</div>
                <div class="exchangeNum listTitleStyle">近期交易次数</div>
                <div class="exchangeNum listTitleStyle">胜率</div>
                <div class="exchangeLine listTitleStyle">盈利曲线</div>
                <div class="exchangeNum listTitleStyle">24H盈亏</div>
                <div class="exchangeLine listTitleStyle">7天盈亏</div>
                <div class="exchangeLine listTitleStyle">30天盈亏</div>
                <div class="exchangeLine listTitleStyle">盈亏 </div>
                <div class="doBox listTitleStyle">操作 </div>
            </div>
            <div v-for="(v,k) in this.list" :key="k" class="listItembBox " >
                <div class="num listItemStyle">{{ k + 1}}</div>
                <div class="address listItemStyle">
                    <div class="addressText"  @click="handleCopy(v.address)">{{v.address}}</div>
                </div>
                <div class="exchangeNumList listItemStyle colorBlue">{{v.trade_times}}</div>
                <div class="exchangeNumList listItemStyle colorBlue" >{{ v.win_rate }}</div>
                <div class="exchangeNumList listItemStyle colorBlue echartBox">
                    <!-- <v-chart class="chart" :ref="'chart' + k"></v-chart> -->
                    <div class="chart" :ref="'chart' + k" :id="'chart' + k"></div>
                </div>
                <div
                    class="lineList listItemStyle"
                    :class="getPnlClass(v.day_pnl)"
                >${{ numberToCurrencyNo(v.day_pnl) }}</div>
                <div
                    class="lineList listItemStyle"
                    :class="getPnlClass(v.week_pnl)"
                >${{ numberToCurrencyNo(v.week_pnl) }}</div>
                <div
                    class="lineList listItemStyle"
                    :class="getPnlClass(v.month_pnl)"
                >${{ numberToCurrencyNo(v.month_pnl) }}</div>
                <div
                  class="lineList listItemStyle"
                  :class="getPnlClass(v.all_pnl)"
                >${{ numberToCurrencyNo(v.all_pnl) }}</div>
                <div class="doList listItemStyle">
                    <img
                        class="flowImg"
                        src="@/assets/flowOrder.png"
                        @click="goToTerminal(v.address)" alt=""
                    >
                    <div class="flowText">跟单</div>
                    <div class="buyText" @click="goToTrade()">去交易</div>
                    <img class="buyImg" src="@/assets/buy.png" @click="goToScan(v.address)" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 全量引入
import * as echarts from 'echarts';

import {
    getSmartMoneyList,
} from '@/api/data'

import { numberToCurrencyNo, formatTimestamp } from '@/util/utils';

    export default {
        name: 'index',
    components: {
    },
    data () {
        return {
            loading: false,
            noDataText: '暂无数据',

            columns: [
                {
                  title: 'index', key: 'index', slot: 'address', align: 'left'
                },
                {
                  title: '总值', key: 'account_value', align: 'left'
                },
                {
                  title: 'PNL(day)', key: "day_pnl", slot: 'day_pnl', sortable: "custom", align: 'left'
                },
                {
                  title: 'ROI(day)', key: "day_roi", slot: 'day_roi', sortable: "custom", align: 'left'
                },
                {
                  title: 'VLM(day)', key: "day_vlm", slot: 'day_vlm', sortable: "custom", align: 'left'
                },
                {
                  title: '日期', key: 'date', align: 'center', width: 100
                },
            ],
            list: [],

            pagination: {
                page: 1,
                total: 0,
                size: 20
            },

            search: {
                address: '',
            },

            charts: []
        };
    },
    methods: {
        numberToCurrencyNo,

        getPnlClass(pnl) {
            return pnl < 0 ? 'colorRed' : 'colorBlue';
        },
        // 列表
        getList () {
            this.loading = true
            getSmartMoneyList({
                ...this.pagination,
                ...this.search,
            }).then(
                (res) => {
                    this.loading = false;
                    if (res.status === 1) {
                        this.$Message.error(res.message);
                        return false;
                    }
                    this.pagination.total = res.data.total;
                    this.list = res.data !== null ? res.data.data : [];
                    this.renderCharts();
                    return true; // 确保所有路径都返回值
                }
            );
        },

        renderCharts() {
            this.$nextTick(() => {
                this.list.forEach((item, index) => {
                    const dom = this.$refs[`chart${index}`];
                    const chartDom = Array.isArray(dom) ? dom[0] : dom;
                    // console.log(item);
                    // const chartDom = document.getElementById('chart' + index);
                    // console.log(chartDom);
                    if (chartDom) {
                        const myChart = echarts.init(chartDom);
                        const option = {
                            // 数据超出容器，使用容器内限位
                            grid: {
                                top: '2',
                                left: '2',
                                right: '0',
                                bottom: '2',
                                containLabel: true
                            },
                            tooltip: {
                                trigger: 'axis',
                                valueFormatter: (value) => `$${value.toFixed(2)}`,
                                className: 'tooltipBox',
                                formatter: (params) => {
                                    const ymd = formatTimestamp(params[0].data[0])
                                    // 不使用 item.marker
                                    let result = `${ymd}<br/>`;
                                    params.forEach((v) => {
                                        result += `盈利：$${v.data[1].toFixed(2)}`;
                                    });
                                    return result;
                                }
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: false,
                                axisLine: { show: false },
                                axisTick: { show: false },
                                axisLabel: { show: false },
                                splitLine: { show: false },

                            },
                            yAxis: {
                                axisLine: { show: false },
                                axisTick: { show: false },
                                axisLabel: { show: false },
                                splitLine: { show: false },
                                type: 'value',
                            },
                            series: [
                                {
                                    type: 'line',
                                    showSymbol: false,
                                    data: item.chart,
                                    smooth: true,
                                    areaStyle: {
                                        color: '#25302b'
                                    },
                                    lineStyle: {
                                        color: '#abfcdf', // 👉 线条颜色
                                        width: 1
                                    },
                                }
                            ]
                        };
                        myChart.setOption(option);
                        myChart.resize();
                    }
                })
            })
        },

        // 进入 terminal
        goToTerminal(address) {
            const tempWindows = window.open("_blank");
            tempWindows.location = `https://hyperterminal.xyz/address/${address}`;
        },

        // 进入区块浏览器
        goToScan(address) {
            const tempWindows = window.open("_blank");
            tempWindows.location = `https://hypurrscan.io/address/${address}`;
        },

        // 邀请进入hyperliquid链接
        goToTrade() {
            const tempWindows = window.open("_blank");
            tempWindows.location = "https://app.hyperliquid.xyz/join/NTOD";
        },

        handleCopy(address) {
            this.$Copy({
                    text: address,

                })
        },

        changeTableSort(data) {
            this.sort.column = data.key;
            this.sort.order = data.order;
            this.getList();
        },
        routerToDetail(address) {
            this.$router.push(`/hyper/hyper-smart-money-detail/${address}`);
        }
    },
    mounted () {
        this.getList();
        // this.initTPL();
    }
}
</script>
<style lang="less" scoped>
.tooltipBox {
    width: 200px;
}
.indexBox{
    width: 100%;
    padding: 0 120px;
    background: #121212;
}
.title{
    font-weight: bold;
    font-size: 36px;
    color:#fff;
    padding:46px 0 30px 0;
}
.listBox{
    background: #121212;
    width: 100%;
    .listTitleBox{
        width: 100%;height: 50px;
        display: flex;
        justify-content: space-around;
        .numTitle{
            width: 66px;
            text-align: center;
        }
        .addressTitle{
            width: 340px;
        }
        .exchangeNum{
            width: 83px;
            text-align: center;
        }
        .exchangeLine{
            width: 100px;
            text-align: center;
        }
        .doBox{
            width: 165px;
            margin:0 0 0 30px;
        }
    }
}
.colorBlue{
    color: #009E7F;
}
.colorRed{
    color: #d2253b;
}
.listItembBox{
    width: 100%;
    border-radius: 4px;
    height: 50px;
    background:#1B1B1B;
    margin:0 0 16px 0;
    display: flex;
    justify-content: space-around;
    .num{
        color: #565A62;
        text-align: center;
        width: 66px;
    }
    .address{
        width: 340px;
        cursor: pointer;
        .avatar{
            float:left;
            border-radius:15px ;
            width: 30px;
            height: 30px;
            margin:10px 12px 10px 0;
        }
        .addressText{
            float:left;
            width: 340px;
            color: #A5AFC0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .exchangeNumList{
        width: 83px;
        text-align: center;
    }
    .lineList{
        width: 100px;
        text-align: center;
    }
    .doList{
        margin:0 0 0 30px;
        width: 165px;
        img, div {
            cursor: pointer;
        }
        .flowImg{
            width: 23px;
            height: 23px;
            float:left;
            margin:13.5px 0;
        }
        .buyImg{
            width: 23px;
            height: 23px;
            float:right;
            margin:13.5px 0;
        }
        .flowText,.buyText{
            width: 59.5px;
            float:left;
            line-height: 50px;
            font-size: 14px;
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
        }
        .flowText{
            color:#FF9500;
        }
        .buyText{
            color: #4C78CD;
        }
    }
}
.listTitleStyle{
    height: 50px;
    background: #121212;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    display: inline-block;
}
.listItemStyle{
    line-height: 50px;
    font-size: 14px;
    height: 50px;
    background:#1B1B1B;
    display: inline-block;
}
.echartBox {
    padding: 2px;
    .chart {
        width: 100%;
        height: 100%;
        // margin-bottom: 10px;
    }
}

</style>
